import { render, staticRenderFns } from "./lancar-notas-anos-anteriores-ims.vue?vue&type=template&id=3029c079&"
import script from "./lancar-notas-anos-anteriores-ims.vue?vue&type=script&lang=js&"
export * from "./lancar-notas-anos-anteriores-ims.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports